import { PublicScheduledQueueInfo } from '@/services/catalogApi.service';
import { ConfiguracaoSolucao } from '@/lib/fakeApi';

interface Props {
  queue: PublicScheduledQueueInfo;
  config: ConfiguracaoSolucao;
  onJoin: (queueId: string) => void;
}

export default function ScheduledQueueCard({ queue, config, onJoin }: Props) {
  const isActive = queue.status === 'active';
  const statusLabel = isActive ? 'Aberta' : 'Pausada';
  const statusBadge = isActive ? 'bg-brand-green/10 text-status-ok' : 'bg-brand-attention/10 text-status-attention';
  const textColor = config.corTexto;

  return (
    <div
      className="rounded-xl border border-border bg-scrim/35 backdrop-blur-md p-4 flex items-center gap-4"
      style={{ color: textColor }}
    >
      <span
        className="text-sm font-semibold px-3 py-1 rounded-full shrink-0 bg-primary/10 text-primary"
      >
        {queue.scheduledTime}
      </span>

      <div className="flex-1 min-w-0">
        <p className="font-semibold truncate">{queue.name}</p>
        <div className="flex items-center gap-2 mt-1 text-xs opacity-80">
          <span className={`px-2 py-0.5 rounded-full font-medium ${statusBadge}`}>
            {statusLabel}
          </span>
          {!config.modoAgendamento && (
            <>
              <span>{queue.currentSize} na fila</span>
              <span>~{queue.estimatedWait} min</span>
            </>
          )}
        </div>
      </div>

      <button
        onClick={() => isActive && onJoin(queue.queueId)}
        disabled={!isActive}
        className="px-4 py-2 rounded-full text-sm font-semibold shrink-0 transition-opacity hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed"
        style={
          isActive
            ? { background: config.corPrincipal, color: config.corTexto }
            : { background: 'color-mix(in srgb, var(--text-on-dark) 15%, transparent)', color: textColor }
        }
      >
        {isActive ? 'Agendar' : 'Pausada'}
      </button>
    </div>
  );
}
